import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Component, ViewEncapsulation, ChangeDetectionStrategy, inject, Injectable, Directive, Input, NgModule } from '@angular/core';
import { DotComponentService, NgClassSwitch } from '@ng-dot/core';
const _c0 = ["*"];
class DotPoseStyleComponent {
  static ɵfac = function DotPoseStyleComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotPoseStyleComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DotPoseStyleComponent,
    selectors: [["dot-pose-style"]],
    standalone: false,
    decls: 0,
    vars: 0,
    template: function DotPoseStyleComponent_Template(rf, ctx) {},
    styles: [".dot-column .dot-space,.dot-column hr,.dot-row .dot-space,.dot-row hr{display:block;flex-grow:1;border:none}.dot-row{display:flex;flex-direction:row}.dot-row .dot-bullet{margin-right:.625em}.dot-row._middle{align-items:center}.dot-row._around{justify-content:space-around}.dot-row._between{justify-content:space-between}.dot-column{display:flex;flex-direction:column;height:100%}\n"],
    encapsulation: 2,
    changeDetection: 0
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotPoseStyleComponent, [{
    type: Component,
    args: [{
      selector: 'dot-pose-style',
      template: '',
      encapsulation: ViewEncapsulation.None,
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      styles: [".dot-column .dot-space,.dot-column hr,.dot-row .dot-space,.dot-row hr{display:block;flex-grow:1;border:none}.dot-row{display:flex;flex-direction:row}.dot-row .dot-bullet{margin-right:.625em}.dot-row._middle{align-items:center}.dot-row._around{justify-content:space-around}.dot-row._between{justify-content:space-between}.dot-column{display:flex;flex-direction:column;height:100%}\n"]
    }]
  }], null, null);
})();
class DotPoseStyleService {
  constructor() {
    inject(DotComponentService).append(DotPoseStyleComponent);
  }
  static ɵfac = function DotPoseStyleService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotPoseStyleService)();
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: DotPoseStyleService,
    factory: DotPoseStyleService.ɵfac
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotPoseStyleService, [{
    type: Injectable
  }], () => [], null);
})();
class DotColumnDirective {
  constructor(style) {}
  static ɵfac = function DotColumnDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotColumnDirective)(i0.ɵɵdirectiveInject(DotPoseStyleService));
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: DotColumnDirective,
    selectors: [["", "dotColumn", ""]],
    hostAttrs: [1, "dot-column"],
    standalone: false
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotColumnDirective, [{
    type: Directive,
    args: [{
      selector: '[dotColumn]',
      host: {
        class: 'dot-column'
      },
      standalone: false
    }]
  }], () => [{
    type: DotPoseStyleService
  }], null);
})();
class DotRowDirective {
  justify;
  align = 'middle';
  _justifyHolder;
  _alignHolder;
  constructor(style, elementRef) {
    const {
      nativeElement
    } = elementRef;
    this._justifyHolder = new NgClassSwitch(nativeElement, {
      prefix: '_'
    });
    this._alignHolder = new NgClassSwitch(nativeElement, {
      prefix: '_'
    });
  }
  ngOnInit() {
    this._update();
  }
  ngOnChanges(changes) {
    for (let key in changes) {
      if (!changes.hasOwnProperty(key)) {
        continue;
      }
      const change = changes[key];
      const value = change.currentValue;
      this[key] = value;
      switch (key) {
        case 'justify':
        case 'align':
          this._update();
          break;
      }
    }
  }
  _update() {
    const {
      _justifyHolder,
      justify,
      _alignHolder,
      align
    } = this;
    if (justify) {
      _justifyHolder.set(justify);
    } else {
      _justifyHolder.pop();
    }
    if (align) {
      _alignHolder.set(align);
    } else {
      _alignHolder.pop();
    }
  }
  static ɵfac = function DotRowDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotRowDirective)(i0.ɵɵdirectiveInject(DotPoseStyleService), i0.ɵɵdirectiveInject(i0.ElementRef));
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: DotRowDirective,
    selectors: [["", "dotRow", ""]],
    hostAttrs: [1, "dot-row"],
    inputs: {
      justify: "justify",
      align: "align"
    },
    standalone: false,
    features: [i0.ɵɵNgOnChangesFeature]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotRowDirective, [{
    type: Directive,
    args: [{
      selector: '[dotRow]',
      host: {
        class: 'dot-row'
      },
      standalone: false
    }]
  }], () => [{
    type: DotPoseStyleService
  }, {
    type: i0.ElementRef
  }], {
    justify: [{
      type: Input
    }],
    align: [{
      type: Input
    }]
  });
})();
class DotSpaceComponent {
  static ɵfac = function DotSpaceComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotSpaceComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DotSpaceComponent,
    selectors: [["dot-space"]],
    hostAttrs: [1, "dot-space"],
    standalone: false,
    features: [i0.ɵɵProvidersFeature([])],
    ngContentSelectors: _c0,
    decls: 1,
    vars: 0,
    template: function DotSpaceComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    encapsulation: 2,
    changeDetection: 0
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotSpaceComponent, [{
    type: Component,
    args: [{
      selector: 'dot-space',
      template: `
		<ng-content></ng-content>`,
      encapsulation: ViewEncapsulation.None,
      changeDetection: ChangeDetectionStrategy.OnPush,
      host: {
        class: 'dot-space'
      },
      providers: [],
      standalone: false
    }]
  }], null, null);
})();
const DOT_POSE_VIEWS = [DotPoseStyleComponent, DotSpaceComponent, DotRowDirective, DotColumnDirective];
class DotPoseModule {
  static ɵfac = function DotPoseModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotPoseModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: DotPoseModule
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    providers: [DotPoseStyleService],
    imports: [CommonModule]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotPoseModule, [{
    type: NgModule,
    args: [{
      declarations: DOT_POSE_VIEWS,
      imports: [CommonModule],
      exports: DOT_POSE_VIEWS,
      providers: [DotPoseStyleService]
    }]
  }], null, null);
})();

/**
 * Generated bundle index. Do not edit.
 */

export { DOT_POSE_VIEWS, DotColumnDirective, DotPoseModule, DotPoseStyleComponent, DotPoseStyleService, DotRowDirective, DotSpaceComponent };
